module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-84.5165e734.svg";